import { GridColumnsPanel, GridSlotProps } from '@mui/x-data-grid-pro';
import { useTheme } from '@mui/material/styles';

export default function CustomColumnsPanel(
  props: GridSlotProps['columnsPanel']
) {
  const theme = useTheme();
  return (
    <GridColumnsPanel
      {...props}
      sx={[
        {
          maxHeight: 450,
          width: 257,
          paddingX: 2,
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.background.paper
              : theme.palette.semantic.surface.bg2,
          border: '0.5px solid',
          borderColor: theme.palette.semantic.outline.light,
          borderRadius: '4px',

          // Checkboxes and Show All/Hidden All
          '& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate, & .MuiCheckbox-root.Mui-indeterminate':
            {
              color:
                theme.palette.mode === 'dark'
                  ? theme.palette.colors.info[400]
                  : undefined,
            },

          // Header
          '& .MuiDataGrid-columnsManagementHeader': {
            borderBottom: 'unset',
            paddingX: 0,
          },

          // Search Bar
          '& .MuiDataGrid-columnsManagementHeader .MuiInputBase-input': {
            fontSize: '14px',

            '&::placeholder': {
              fontSize: '14px',
              opacity: 1,
            },
          },

          '& .MuiFormControlLabel-label': {
            fontSize: '14px !important',
          },

          '& .MuiDataGrid-columnsManagementHeader .MuiTextField-root': {
            '& .MuiOutlinedInput-root': {
              backgroundColor: theme.palette.background.default,
            },

            '& .MuiInputBase-input': {
              fontSize: '14px',
            },

            '& .MuiInputBase-input::placeholder': {
              fontSize: '14px',
              color: theme.palette.text.secondary,
              opacity: 1,
            },

            '& .MuiInputAdornment-root': {
              color: theme.palette.text.secondary,
            },
          },
          '&:has(.MuiInputBase-input:not(:placeholder-shown)) .MuiOutlinedInput-root':
            {
              backgroundColor: 'transparent',
            },

          // Main Selection
          '& .MuiDataGrid-columnsManagement': {
            paddingX: 0,
            gap: '8px',
          },

          // Footer (Show All/HideAll and Reset Button)
          '& .MuiDataGrid-columnsManagementFooter': {
            paddingX: 0,
          },

          '& [class*="MuiDataGrid-columnsManagementScrollArea"]': {
            maxHeight: '425px !important',
          },

          '& .MuiDataGrid-columnsManagementFooter button': {
            fontSize: '14px',
            textTransform: 'none',
            textDecoration: 'underline',
            color: theme.palette.semantic.hyperlink.active,
            '&:hover': {
              color: theme.palette.semantic.hyperlink.hover,
            },

            '&:disabled': {
              color: theme.palette.semantic.hyperlink.disabled,
            },
          },
        },
      ]}
    />
  );
}
